import React from 'react';
import './App.scss';
import 'common.ui/dist/index.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { MsalProvider } from 'auth/MsalContext';
import ReactNotification, { store } from 'react-notifications-component';
import { RegisterErrorCallback, RegisterError, RegisterMaintenanceCallback } from 'helpers/errorHandling/ErrorHandling';
import { UserProvider } from 'contexts/UserContext';
import RoutePaths from 'RoutePaths';
import { Routes } from './Routing';
import 'localization/LanguageConfig';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from 'ApplicationInsightsService';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false
    }
  }
});

class App extends React.Component {
  componentDidMount() {
    RegisterMaintenanceCallback(() => (window.location.href = RoutePaths.underMaintenance));
    RegisterErrorCallback((err) => {
      store.addNotification({
        message: err,
        type: 'danger',
        insert: 'top',
        container: 'top-right',
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
          duration: 10000
        }
      });
    });
    window.onerror = (err: Event | string) => {
      RegisterError(err);
    };
  }

  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <Router>
            <AppInsightsContext.Provider value={reactPlugin}>
              <MsalProvider>
                <UserProvider>
                  <ReactNotification />
                  <Routes />
                </UserProvider>
              </MsalProvider>
            </AppInsightsContext.Provider>
          </Router>
        </HelmetProvider>
      </QueryClientProvider>
    );
  }
}

export default App;
